import React from 'react'
import { Power, Split, Timer, Lightbulb, Repeat, Undo2, Ban } from 'lucide-react'
import './flowBlocks.css'

// One place that maps a flowchart block type to its colour class, label and
// icon. Used by both the canvas nodes (Myflowchart text/text1) and the sidebar
// palette (Sidebar) so a block's look is defined once.
export const FLOW_BLOCK_META = {
    start: { mod: 'start', label: 'Start', Icon: Power },
    if: { mod: 'decision', label: 'Decision', Icon: Split },
    output: { mod: 'action', label: 'Action', Icon: Lightbulb },
    wait: { mod: 'wait', label: 'Wait', Icon: Timer },
    loop: { mod: 'repeat', label: 'Repeat', Icon: Repeat },
    'end/repeat': { mod: 'loop', label: 'Loop', Icon: Undo2 },
    end: { mod: 'end', label: 'End', Icon: Ban },
    end1: { mod: 'end', label: 'End', Icon: Ban },
    endl: { mod: 'end', label: 'End', Icon: Ban },
}

// The gradient pill (icon + label). Extra className / props (id, drag handlers,
// style) are forwarded so canvas nodes pass "Image-render" and the sidebar
// passes its "dndnode_* fcTile" classes + drag handlers onto the same element.
const FlowBlockPill = React.forwardRef(function FlowBlockPill(
    { type, className = '', ...rest },
    ref
) {
    const meta = FLOW_BLOCK_META[type] || FLOW_BLOCK_META.output
    const Icon = meta.Icon
    return (
        <div
            ref={ref}
            className={`fcBlock fcBlock--${meta.mod} ${className}`}
            {...rest}
        >
            <Icon className="fcBlock__icon" size={16} />
            <span className="fcBlock__label">{meta.label}</span>
        </div>
    )
})

export default FlowBlockPill
